import api from './api';

export const listPartners = () =>
  api.get('/admin/affiliates').then(r => r.data.partners);

export const getPartnerDetail = (id) =>
  api.get(`/admin/affiliates/${id}`).then(r => r.data);

export const getPreviewDashboard = (id) =>
  api.get(`/admin/affiliates/${id}/preview-dashboard`).then(r => r.data);

export const approveLandingPage = (id) =>
  api.post(`/admin/affiliates/${id}/approve-landing-page`).then(r => r.data.partner);

export const unapproveLandingPage = (id) =>
  api.post(`/admin/affiliates/${id}/unapprove-landing-page`).then(r => r.data.partner);

export const createPartner = (fields) =>
  api.post('/admin/affiliates', fields).then(r => r.data.partner);

export const updatePartner = (id, fields) =>
  api.put(`/admin/affiliates/${id}`, fields).then(r => r.data.partner);

export const updateIntakeProfile = (id, fields) =>
  api.put(`/admin/affiliates/${id}/intake-profile`, fields).then(r => r.data.partner);

export const recordPayout = (id, fields) =>
  api.post(`/admin/affiliates/${id}/payouts`, fields).then(r => r.data.payout);

export const sendIntakeEmail = (id, fields) =>
  api.post(`/admin/affiliates/${id}/send-intake-email`, fields || {}).then(r => r.data);

export const getIntakeEmailPreview = (id) =>
  api.get(`/admin/affiliates/${id}/intake-email-preview`).then(r => r.data);

export const renderIntakeEmailPreview = (id, fields) =>
  api.post(`/admin/affiliates/${id}/intake-email-render`, fields).then(r => r.data.html);

export const getApprovalEmailPreview = (id) =>
  api.get(`/admin/affiliates/${id}/approval-email-preview`).then(r => r.data);

export const renderApprovalEmailPreview = (id, fields) =>
  api.post(`/admin/affiliates/${id}/approval-email-render`, fields).then(r => r.data.html);

export const sendApprovalEmail = (id, fields) =>
  api.post(`/admin/affiliates/${id}/send-approval-email`, fields || {}).then(r => r.data);

export const listMedia = (partnerId, platform) =>
  api.get('/admin/affiliate-media', { params: { ...(partnerId ? { partnerId } : {}), ...(platform ? { platform } : {}) } }).then(r => r.data.media);

export const createMedia = (fields) =>
  api.post('/admin/affiliate-media', fields).then(r => r.data.media);

export const deleteMedia = (id) =>
  api.delete(`/admin/affiliate-media/${id}`).then(r => r.data);

export const updateMediaSharing = (id, partnerId) =>
  api.put(`/admin/affiliate-media/${id}/sharing`, { partnerId: partnerId || null }).then(r => r.data.media);
